module.exports = "/_next/static/images/58bd504dccaadb9d66bcdd93548c6745-boy-looking-to-the-front-md@3x.jpg.webp";